<script>
import ListBlogPagesComponent from '../features/lists/ListBlogPagesComponent';
import FooterView from '../../shared/views/MainFooterView';
import BrandLogo from '../../shared/BrandLogo.vue';
export default {
  name: 'BlogPageView',
  components: {
        'brand-logo': BrandLogo,
    'footer-view': FooterView,
  },
  extends: ListBlogPagesComponent,
};
</script>

<template>
  <div class="public-page-wrapper">
    <!-- Header -->
    <header class="public-header">
      <div class="public-header__inner">
        <router-link to="/">
          <brand-logo variant="dark" />
        </router-link>
        <nav class="public-header__nav">
          <router-link to="/">Inicio</router-link>
          <router-link to="/acerca">Acerca</router-link>
          <router-link to="/cursos">Cursos</router-link>
          <router-link to="/noticias">Noticias</router-link>
          <router-link to="/contacto">Contacto</router-link>
        </nav>
        <div class="public-header__actions">
          <router-link
            to="/login"
            class="btn-outline"
          >
            Iniciar Sesión
          </router-link>
          <router-link
            to="/registrarse"
            class="btn-fill"
          >
            Registrarse
          </router-link>
        </div>
      </div>
    </header>

    <!-- Hero -->
    <section class="public-hero">
      <div class="public-hero__inner">
        <nav class="public-hero__nav">
          <router-link to="/">Inicio</router-link>
          <span>/</span>
          <a
            href="#"
            class="active"
          >Noticias</a>
        </nav>
        <h1 class="public-hero__title">Publicaciones y Noticias</h1>
        <p class="public-hero__subtitle">Artículos educativos, novedades de la plataforma y consejos para tu desarrollo profesional.</p>
      </div>
    </section>

    <!-- Body -->
    <main class="public-body">
      <div class="row">
        <!-- Sidebar -->
        <div class="col-lg-3 col-md-4 mb-24">
          <div class="public-card blog-sidebar">
            <div class="public-card__accent-bar" />
            <h3>Buscar</h3>
            <div class="blog-search-box">
              <el-input
                v-model="filterOptions.titleFilter"
                size="small"
                placeholder="Buscar artículos..."
                prefix-icon="el-icon-search"
                clearable
                @keyup.enter="onAllFilterChange(filterOptions.titleFilter, 'Title')"
              />
            </div>

            <div class="public-card__divider" />

            <h3>Explorar</h3>
            <ul class="blog-categories">
              <li>
                <router-link to="/noticias">
                  <i class="uil uil-apps" /> Todos los Artículos
                </router-link>
              </li>
              <li>
                <router-link to="/noticias">
                  <i class="uil uil-graduation-cap" /> Educación
                </router-link>
              </li>
              <li>
                <router-link to="/noticias">
                  <i class="uil uil-lightbulb" /> Consejos y Trucos
                </router-link>
              </li>
              <li>
                <router-link to="/noticias">
                  <i class="uil uil-rocket" /> Novedades
                </router-link>
              </li>
              <li>
                <router-link to="/noticias">
                  <i class="uil uil-users-alt" /> Comunidad
                </router-link>
              </li>
            </ul>

            <div class="public-card__divider" />

            <div class="blog-help-box">
              <h4>¿Tienes dudas?</h4>
              <p>Visita nuestro centro de soporte.</p>
              <router-link
                to="/soporte"
                class="btn-outline blog-help-btn"
              >
                <i class="uil uil-headphones" /> Ir a Soporte
              </router-link>
            </div>
          </div>
        </div>

        <!-- Content -->
        <div
          v-loading="fullLoader"
          class="col-lg-9 col-md-8"
          element-loading-text="Cargando publicaciones..."
        >
          <div class="blog-post-list">
            <div
              v-for="(post) in collection"
              :key="post.id"
              class="blog-post-card"
            >
              <div class="blog-post-card__image">
                <a
                  class="course-pointer"
                  @click="navigate(post)"
                >
                  <img
                    :src="mapPostImageUrl(post)"
                    :alt="post.title"
                  >
                  <div class="blog-post-card__overlay" />
                </a>
              </div>
              <div class="blog-post-card__content">
                <div class="blog-post-card__meta">
                  <i class="uil uil-calendar-alt" />
                  {{ formatDate(post.createdAt) }}
                </div>
                <h3 class="blog-post-card__title">
                  <a
                    class="course-pointer"
                    @click="navigate(post)"
                  >
                    {{ post.title }}
                  </a>
                </h3>
                <p class="blog-post-card__excerpt">
                  {{ descriptionStrippedHtml(post.description) }}
                </p>
                <a
                  class="blog-post-card__link course-pointer"
                  @click="navigate(post)"
                >
                  Leer más <i class="uil uil-arrow-right" />
                </a>
              </div>
            </div>

            <!-- Empty state -->
            <div
              v-if="!fullLoader && collection.length === 0"
              class="blog-empty-state"
            >
              <i class="uil uil-newspaper" />
              <h3>No hay publicaciones</h3>
              <p>Intenta ajustar tu búsqueda o explora todas las publicaciones.</p>
              <el-button
                type="primary"
                size="small"
                @click="filterOptions.titleFilter = ''; onAllFilterChange('', 'Title')"
              >
                Ver todas las publicaciones
              </el-button>
            </div>
          </div>

          <!-- Pagination -->
          <div
            v-if="pagination.totalPages > 1"
            class="blog-pagination"
          >
            <el-pagination
              v-model:current-page="currentPage"
              background
              layout="prev, pager, next"
              :page-count="pagination.totalPages"
              @current-change="onPageChange"
            />
          </div>
        </div>
      </div>
    </main>

    <footer-view />
  </div>
</template>

<style scoped>
.mb-24 {
  margin-bottom: 24px;
}

.blog-sidebar {
  padding: 20px;
}

.blog-sidebar h3 {
  font-size: 0.9375rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 12px;
}

.blog-search-box {
  margin-bottom: 4px;
}

.blog-categories {
  list-style: none;
  padding: 0;
  margin: 0;
}

.blog-categories li {
  margin-bottom: 4px;
}

.blog-categories li:last-child {
  margin-bottom: 0;
}

.blog-categories a {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Roboto', sans-serif;
  font-size: 0.875rem;
  color: #475569;
  text-decoration: none;
  padding: 8px 10px;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.blog-categories a i {
  color: #94a3b8;
  font-size: 16px;
  transition: color 0.2s ease;
}

.blog-categories a:hover {
  color: #0D47A1;
  background: #EEF5FC;
}

.blog-categories a:hover i {
  color: #0D47A1;
}

.blog-help-box {
  background: linear-gradient(135deg, #EEF5FC, #D6E7F8);
  border-radius: 10px;
  padding: 16px;
  text-align: center;
}

.blog-help-box h4 {
  font-size: 0.9375rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 6px;
}

.blog-help-box p {
  font-size: 0.8125rem;
  color: #64748b;
  margin: 0 0 12px;
}

.blog-help-btn {
  font-size: 0.8125rem;
  padding: 8px 14px;
  border-radius: 8px;
}

/* Blog Post Cards */
.blog-post-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.blog-post-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  display: flex;
  flex-direction: column;
}

.blog-post-card:hover {
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.1);
  transform: translateY(-2px);
}

.blog-post-card__image {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.blog-post-card__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.blog-post-card:hover .blog-post-card__image img {
  transform: scale(1.05);
}

.blog-post-card__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, transparent 50%, rgba(15, 23, 42, 0.3) 100%);
}

.blog-post-card__content {
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.blog-post-card__meta {
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: 'Roboto', sans-serif;
  font-size: 0.8125rem;
  color: #94a3b8;
  margin-bottom: 12px;
}

.blog-post-card__meta i {
  font-size: 14px;
}

.blog-post-card__title {
  font-family: 'Roboto', sans-serif;
  font-size: 1.125rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 12px;
  line-height: 1.4;
}

.blog-post-card__title a {
  color: inherit;
  text-decoration: none;
  transition: color 0.2s ease;
}

.blog-post-card__title a:hover {
  color: #0D47A1;
}

.blog-post-card__excerpt {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9375rem;
  color: #64748b;
  line-height: 1.6;
  margin: 0 0 16px;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.blog-post-card__link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-family: 'Roboto', sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  color: #0D47A1;
  text-decoration: none;
  transition: all 0.2s ease;
}

.blog-post-card__link i {
  font-size: 14px;
  transition: transform 0.2s ease;
}

.blog-post-card__link:hover {
  color: #1565C0;
}

.blog-post-card__link:hover i {
  transform: translateX(4px);
}

/* Empty State */
.blog-empty-state {
  text-align: center;
  padding: 60px 20px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.blog-empty-state i {
  font-size: 48px;
  color: #cbd5e1;
  margin-bottom: 16px;
  display: block;
}

.blog-empty-state h3 {
  font-family: 'Roboto', sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 8px;
}

.blog-empty-state p {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9375rem;
  color: #64748b;
  margin: 0 0 20px;
}

/* Pagination */
.blog-pagination {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}

/* Responsive */
@media (max-width: 768px) {
  .blog-post-card__image {
    height: 180px;
  }

  .blog-post-card__content {
    padding: 16px;
  }

  .blog-post-card__title {
    font-size: 1rem;
  }
}
</style>

